import axios from "./api-client";
import API from "../constants/apis";

export const signin = async (data) => {
  return axios.post(API.LOGIN, data);
};

export const oauthRegisterLogin = async (data) => {
  return axios.post(API.OAUTH_REGISTER_LOGIN, data);
};

export const getUser = async () => {
  return axios.get(API.GET_ME);
};

export const getDwollaBalance = async (data) => {
  return axios.post(API.GET_DWOLLA_BALANCE, data);
};
